<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i class="fa fa-bars mr-1"></i>
            <span>Datepickers</span>
          </b-col>
        </b-row>
      </b-card-header>

      <b-card-title class="my-4"> Datepicker1</b-card-title>
      <b-card-body>
        <b-row>
          <b-col cols="3">
            <b-form-group label-cols="12" label="Date From" label-size="sm">
              <b-input-group>
                <b-form-datepicker
                  size="sm"
                  v-model="Datepicker1.datefrom"
                  label-help
                  hide-header
                  locale="en-GB"
                  placeholder="Date From"
                  :debounce="options.debounce"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                ></b-form-datepicker>

                <b-input-group-append>
                  <b-button
                    size="sm"
                    squared
                    variant="outline-secondary"
                    :disabled="!Datepicker1.datefrom"
                    @click="Datepicker1.datefrom = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group label-cols="12" label="Date To" label-size="sm">
              <b-input-group>
                <b-form-datepicker
                  size="sm"
                  v-model="Datepicker1.dateto"
                  label-help
                  hide-header
                  locale="en-GB"
                  placeholder="Date To"
                  :debounce="options.debounce"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                ></b-form-datepicker>

                <b-input-group-append>
                  <b-button
                    size="sm"
                    squared
                    variant="outline-secondary"
                    :disabled="!Datepicker1.dateto"
                    @click="Datepicker1.dateto = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>

      <b-card-title class="my-4"> Datepicker2</b-card-title>
      <b-card-body>
        <b-row>
          <b-col cols="3">
            <b-form-group label-cols="12" label="Date" label-size="sm">
              <!-- :timePicker="true"
                      :timePicker24Hour="true" -->
              <b-input-group>
                <daterangepicker
                  size="sm"
                  ref="date"
                  v-model="Datepicker2.date"
                  :opens="'right'"
                  :locale-data="locale_data"
                  :ranges="locale_ranges" :showDropdowns="true"
                  :linkedCalendars="true"
                  :single-date-picker="'range'"
                >
                </daterangepicker>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="
                      date = {
                        startDate: null,
                        endDate: null,
                      }
                    "
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group> </b-col
        ></b-row>
      </b-card-body>

      <b-card-title class="my-4"> Datepicker3</b-card-title>
      <b-card-body>
        <b-row>
          <b-col cols="3">
            <!-- :timePicker="true"
                      :timePicker24Hour="true" -->
            <b-form-group label-cols="12" label="Date From" label-size="sm">
              <b-input-group>
                <v-date-picker
                  v-model="Datepicker3.datefrom"
                  mode="date"
                  is24hr
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="
                        px-2
                        py-1
                        border
                        focus:outline-none focus:border-primary
                        form-control
                        reportrange-text
                      "
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    squared
                    variant="outline-secondary"
                    :disabled="!Datepicker3.datefrom"
                    @click="Datepicker3.datefrom = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <!-- :timePicker="true"
                      :timePicker24Hour="true" -->
            <b-form-group label-cols="12" label="Date To" label-size="sm">
              <b-input-group>
                <v-date-picker
                  v-model="Datepicker3.dateto"
                  mode="date"
                  is24hr
                  color="green"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="
                        px-2
                        py-1
                        border
                        focus:outline-none focus:border-primary
                        form-control
                        reportrange-text
                      "
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    squared
                    variant="outline-secondary"
                    :disabled="!Datepicker3.dateto"
                    @click="Datepicker3.dateto = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>

      <b-card-title class="my-4"> Datepicker3B</b-card-title>
      <b-card-body>
        <b-row>
          <b-col cols="3">
            <b-form-group label-cols="12" label="Date From" label-size="sm">
              <b-input-group>
                <v-date-picker
                  v-model="Datepicker3.datefrom"
                  mode="date"
                  color="green"
                  is24hr
                  class="form-control form-control-sm"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="
                        h-20px
                        border-none
                        focus:outline-none focus:border-primary
                        text-primary
                      "
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    squared
                    variant="outline-secondary"
                    :disabled="!Datepicker3.datefrom"
                    @click="Datepicker3.datefrom = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group label-cols="12" label="Date To" label-size="sm">
              <b-input-group>
                <v-date-picker
                  v-model="Datepicker3.dateto"
                  mode="date"
                  is24hr
                  color="green"
                  class="form-control form-control-sm"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="
                        h-20px
                        border-none
                        focus:outline-none focus:border-primary
                        text-primary
                      "
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    squared
                    variant="outline-secondary"
                    :disabled="!Datepicker3.dateto"
                    @click="Datepicker3.dateto = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>

      <b-card-title class="my-4"> Datepicker4 (vc-single)</b-card-title>
      <b-card-body>
        <b-row>
          <b-col cols="3">
            <b-form-group label-cols="12" label="Date" label-size="sm">
              <b-input-group>
                <vc-single v-model="Datepicker4"> </vc-single>

                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="Datepicker4 = null"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <!-- {{ Datepicker4 }} -->
        </b-row>
      </b-card-body>

      <b-card-title class="my-4"> Datepicker5 (vc-range)</b-card-title>
      <b-card-body>
        <b-row>
          <b-col cols="4">
            <b-form-group
              label-cols="12"
              label="Start/End Date"
              label-size="sm"
            >
              <b-input-group>
                <vc-range v-model="Datepicker5"></vc-range>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="Datepicker5 = null"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        {{ Datepicker5 }}
      </b-card-body>
    </b-card>
  </div>
</template>
  
  <script>
export default {
  name: "Datepickers",
  data() {
    return {
      busy: false,
      options: {
        debounce: 500,
      },

      Datepicker1: {
        datefrom: "2022-10-01",
        dateto: "2022-10-31",
      },
      Datepicker2: {
        date: {
          startDate: this.$moment().startOf("year").format("YYYY-MM-DD"),
          endDate: this.$moment().format("YYYY-MM-DD"),
        },
      },
      Datepicker3: {
        datefrom: new Date(),
        dateto: new Date(),
      },
      Datepicker4: new Date(),

      Datepicker5: {
        start: new Date(),
        end: new Date(),
      },
    };
  },

  methods: {},
};
</script>
  